import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

export interface PermissionDeniedModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Permission Denied Modal Component
 * Displays a generic permission error message as specified in the design
 * Based on GenericAlertModal structure
 */
export const PermissionDeniedModal: React.FC<PermissionDeniedModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      onBackdropClick={onClose}
      PaperProps={{
        style: {
          width: "100%",
          maxWidth: "295px",
          display: "flex",
          backgroundColor: "#DED9F8", // Light purple background
          textAlign: "center",
          borderRadius: "2rem",
          minHeight: "220px",
        },
      }}
    >
      <DialogContent
        style={{
          textAlign: "left",
          padding: "2.25rem 1.25rem 0.75rem 1.25rem",
        }}
      >
        <Typography variant="headlineMedium" color="#261F1F">
          Insufficient permission
        </Typography>
        <DialogContentText variant="bodySmall" color="#564C4C">
          You don't have permission to execute this action or access this
          option.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={{
          paddingRight: "24px",
          paddingBottom: "24px",
          borderTop: "none",
        }}
      >
        <Button
          onClick={onClose}
          variant="text"
          style={{
            color: "#6253A2", // Purple color for Close button
            textTransform: "capitalize",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
